import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { FieldLocationAutocompleteInput } from '../../components';

import css from './CustomExtendedDataField.module.css';

const CustomFieldServiceAddressComponent = props => {
  const { name, fieldConfig, defaultRequiredMessage, formId } = props;
  const intl = useIntl();
  
  const { saveConfig = {} } = fieldConfig || {};
  const { isRequired, requiredMessage, placeholderMessage } = saveConfig;

  const label = intl.formatMessage({ id: 'SignupForm.serviceAddressLabel' });
  const placeholder = placeholderMessage || intl.formatMessage({ id: 'SignupForm.serviceAddressPlaceholder' });
  
  const validate = value => {
    if (isRequired && (!value || !value.selectedPlace)) {
      return requiredMessage || intl.formatMessage({ id: 'SignupForm.serviceAddressRequired' });
    }
    return undefined;
  };

  return (
    <FieldLocationAutocompleteInput
      id={formId ? `${formId}.${name}` : name}
      name={name}
      label={label}
      placeholder={placeholder}
      
      validate={validate}
      className={css.customField}
      CustomIcon={null}
    />
  );
};

const CustomFieldServiceAddress = props => {
  const intl = useIntl();
  return <CustomFieldServiceAddressComponent {...props} intl={intl} />;
};

export default CustomFieldServiceAddress; 